export const generateFieldMask = (fields: object, maskPath: string): string => {
  return Object.keys(fields)
    .reduce((accumulator, fieldName) => accumulator.concat(`${maskPath}.${fieldName}`), [])
    .join(',');
};
